import { applyTokens } from "../../../utilities/applyTokens.js";
import { createFocusStyle } from "../utils/createFocusStyle.js";
const styleSwitchParts = ({ track, thumb }) => ({
    "& + .MuiSwitch-track": track,
    " .MuiSwitch-thumb": thumb,
});
const styleSwitch = (styles) => ({
    "& .MuiButtonBase-root.MuiSwitch-switchBase": styles,
});
const styleCheckedState = ({ checked, unchecked, }) => ({ "&:not(.Mui-checked)": unchecked, "&.Mui-checked": checked });
const createSize = (tokens, size) => {
    const { toggle } = tokens.component;
    const toggleSize = toggle[size];
    return styleSwitch(Object.assign(Object.assign({ " + .MuiSwitch-thumb": {
            transition: "inherit",
        } }, styleCheckedState({
        unchecked: {
            " .MuiSwitch-thumb": {
                transform: `translateX(${toggleSize.bar.padding.value})`,
            },
        },
        checked: {
            " .MuiSwitch-thumb": {
                transform: `translateX(calc(${toggleSize.bar.width.value} - ${toggleSize.knob.width.value} - ${toggleSize.bar.padding.value}))`,
            },
        },
    })), styleSwitchParts({
        track: applyTokens(toggleSize.bar),
        thumb: applyTokens(toggleSize.knob),
    })));
};
const createStates = (tokens, state) => {
    const { toggle } = tokens.component;
    const { default: defaultState, hover, disabled } = toggle[state];
    return Object.assign(Object.assign({}, styleSwitchParts({
        track: applyTokens(defaultState.bar),
        thumb: applyTokens(defaultState.knob),
    })), { "&:hover": styleSwitchParts({
            track: applyTokens(hover.bar),
            thumb: applyTokens(hover.knob),
        }), "&.Mui-disabled": styleSwitchParts({
            track: applyTokens(disabled.bar),
            thumb: applyTokens(disabled.knob),
        }) });
};
const switchTheme = (tokens) => {
    return {
        MuiSwitch: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: Object.assign({ overflow: "visible", padding: 0, width: "unset", height: "unset", alignItems: "center" }, styleSwitch(Object.assign(Object.assign(Object.assign({ width: "100%", height: "100%", padding: 0, top: "unset", justifyContent: "flex-start" }, styleSwitchParts({
                    track: { opacity: 1 },
                    thumb: { opacity: 1, boxShadow: "none" },
                })), styleCheckedState({
                    checked: Object.assign({ transform: `translateX(0)` }, createStates(tokens, "checked")),
                    unchecked: Object.assign({ transform: `translateX(0)` }, createStates(tokens, "unchecked")),
                })), { ":hover": { background: "none" }, "& .MuiSwitch-thumb": { transition: "inherit" }, "& .MuiSwitch-input": { left: 0, width: "auto" }, "&:focus-within + .MuiSwitch-track": createFocusStyle(tokens) }))),
                sizeSmall: createSize(tokens, "small"),
                sizeMedium: createSize(tokens, "large"),
            },
        },
    };
};
export default switchTheme;
//# sourceMappingURL=switch.js.map